module.exports = __webpack_public_path__ + "assets/img/a493-uy.svg";